import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GreffierService {

casiersChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);
jugementsChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);

content_noteAudience: BehaviorSubject<any> = new BehaviorSubject<any>(null);
content_factas: BehaviorSubject<any> = new BehaviorSubject<any>(null);
content_qualite: BehaviorSubject<any> = new BehaviorSubject<any>(null);


    amenistie_modules = [
        {
            "id": 1,
            "name": "Amnisties"
        },
        {
            "id": 2,
            "name": "Grâces"
        },

    ];

    exec_peines_greffier: any = [
        {
            "title": "Géstion du casier",
            "elements":[
                {
                    "id": 2,
                    "name": "Condamnations",
                    "backgroundImage": "https://cdn-icons-png.flaticon.com/512/5952/5952021.png",
                    "class_color": "l-bg-orange-dark ",
                    "icon": "fas fa-duotone fa-gavel"

                },
                {
                "id": 1,
                "name": "Parcourir les casiers",
                "backgroundImage": "https://img.freepik.com/vecteurs-premium/documents-dossier-cachet-texte-contrat-approbation-cachet_349999-535.jpg",
                "class_color": "l-bg-custom",
                "icon": "fas fa-regular fa-file"
                },

                {
                "id": 3,
                "name": "Génération de casier",
                "backgroundImage": "https://img.freepik.com/vecteurs-premium/documents-dossier-cachet-texte-contrat-approbation-cachet_349999-535.jpg",
                "class_color": "l-bg-cherry",
                "icon": "fas fa-regular fa-file"
                },

                {
                    "id": 6,
                    "name": "Fichier de police",
                    "backgroundImage": "https://www.exprime-avocat.fr/wp-content/uploads/2023/01/Amende-contraventionnelle-scaled.jpg",
                    "class_color": "l-bg-blue-green2",
                    "icon": "fas fa-solid fa-paste"
                },
                {
                    "id": 8,
                    "name": "Amnisties/Rectifications",
                    "backgroundImage": "https://www.exprime-avocat.fr/wp-content/uploads/2023/01/Amende-contraventionnelle-scaled.jpg",
                    "class_color": "l-bg-yellow-dark-amnestie",
                    "icon": "fas fa-solid fa-file-invoice"
                },


            ]

        },
        {
            "title": "Autres",
            "elements":[
                {
                    "id": 4,
                    "name": "Amendes",
                    "backgroundImage": "https://www.exprime-avocat.fr/wp-content/uploads/2023/01/Amende-contraventionnelle-scaled.jpg",
                    "class_color": "l-bg-green-dark",
                    "icon": "fas fa-solid fa-money-bill-wave"
                },
            ]

        },



      ];

    typeCasiers = [
        {
            "id": 1,
            "name": "CASIER B1"
        },
        {
            "id": 2,
            "name": "CASIER B2"
        },
        {
            "id": 3,
            "name": "CASIER B3"
        },

    ]
  exec_peines: any = [
    {
        "title": "Géstion du casier",
        "elements":[
            {
                "id": 2,
                "is_allowed":1,
                "name": "Condamnations",
                "backgroundImage": "https://cdn-icons-png.flaticon.com/512/5952/5952021.png",
                "class_color": "l-bg-orange-dark ",
                "icon": "fas fa-duotone fa-gavel"

            },

            {
            "id": 1,
            "is_allowed":1,
            "name": "Parcourir les casiers",
            "backgroundImage": "https://img.freepik.com/vecteurs-premium/documents-dossier-cachet-texte-contrat-approbation-cachet_349999-535.jpg",
            "class_color": "l-bg-custom",
            "icon": "fas fa-regular fa-file"
            },

            {
            "id": 3,
             "is_allowed":1,
            "name": "Génération de casier",
            "backgroundImage": "https://img.freepik.com/vecteurs-premium/documents-dossier-cachet-texte-contrat-approbation-cachet_349999-535.jpg",
            "class_color": "l-bg-cherry",
            "icon": "fas fa-regular fa-file"
            },
            {
                "id": 10,
              "is_allowed":1,
                "name": "Génération manuel du casier",
                "backgroundImage": "https://img.freepik.com/vecteurs-premium/documents-dossier-cachet-texte-contrat-approbation-cachet_349999-535.jpg",
                "class_color": "l-bg-mcasier",
                "icon": "fas fa-regular fa-file"
            },
            {
                "id": 5,
               "is_allowed":1,
                "name": "FINADOP",
                "backgroundImage": "https://www.exprime-avocat.fr/wp-content/uploads/2023/01/Amende-contraventionnelle-scaled.jpg",
                "class_color": "l-bg-yellow-dark",
                "icon": "fas fa-regular fa-id-card "
            },

            {
                "id": 6,
                 "is_allowed":1,
                "name": "Fichier de police",
                "backgroundImage": "https://www.exprime-avocat.fr/wp-content/uploads/2023/01/Amende-contraventionnelle-scaled.jpg",
                "class_color": "l-bg-blue-green2",
                "icon": "fas fa-solid fa-paste"
            },
            {
                "id": 8,
              "is_allowed":1,
                "name": "Amnisties/Rectifications",
                "backgroundImage": "https://www.exprime-avocat.fr/wp-content/uploads/2023/01/Amende-contraventionnelle-scaled.jpg",
                "class_color": "l-bg-yellow-dark-amnestie",
                "icon": "fas fa-solid fa-file-invoice"
            },
            {
                "id": 9,
                "is_allowed":1,
                "name": "Demandes",
                "backgroundImage": "https://www.exprime-avocat.fr/wp-content/uploads/2023/01/Amende-contraventionnelle-scaled.jpg",
                "class_color": "l-bg-yellow-dark-demandes",
                "icon": "fas fa-solid fa-list"
            },
            {
              "id": 7,
              "is_allowed":1,
              "name": "Régles de configuration",
              "backgroundImage": "https://www.exprime-avocat.fr/wp-content/uploads/2023/01/Amende-contraventionnelle-scaled.jpg",
              "class_color": "l-bg-grey-dark",
              "icon": "fas fa-solid fa-cubes"
            },

        ]

    },
    {
        "title": "Autres",
        "elements":[
         
            {
                "id": 11,
                "is_allowed":1,
                "name": "Demande Nationalité",
                "backgroundImage": "https://img.freepik.com/vecteurs-premium/documents-dossier-cachet-texte-contrat-approbation-cachet_349999-535.jpg",
                "class_color": "l-bg-orange-dark-nationnalite ",
                "icon": "fas fa-regular fa-file"
            },
            {
                "id": 4,
                "is_allowed":1,
                "name": "Amendes",
                "backgroundImage": "https://www.exprime-avocat.fr/wp-content/uploads/2023/01/Amende-contraventionnelle-scaled.jpg",
                "class_color": "l-bg-green-dark",
                "icon": "fas fa-solid fa-money-bill-wave"
            },

        ]

    },
  ];

  list_ammendes = [
        {
            "name": "R-002-071",
            "numero_jugement": "002",

            "date_de_recouvrement": "2024-06-03",
            "montant_recouvrée": "500000",
            "type_de_paiement": "CASH"
        },
        {
            "name": "R-102-081",
            "numero_jugement": "032",

            "date_de_recouvrement": "2024-10-23",
            "montant_recouvrée": "800000",
            "type_de_paiement": "CASH"
        },
        {
            "name": "R-112-171",
            "numero_jugement": "122",

            "date_de_recouvrement": "2024-08-13",
            "montant_recouvrée": "200000",
            "type_de_paiement": "CASH"
        }
    ]

  list_fichesclasses: any = [
    {
      "name": "0987654321",
      "owner": "Administrator",
      "creation": "2024-04-03 10:52:02.775307",
      "modified": "2024-04-03 10:52:02.775307",
      "modified_by": "Administrator",
      "docstatus": 0,
      "idx": 0,
      "type_didentification": "CIN",
      "numéros_didentification": "0987654321",
      "genre": "Homme",
      "nom": "Anne",
      "prenom": "Ibrahima Ba ",
      "nationalités": "Sénégalais(e)",
      "date_de_naissance": "2020-05-02",
      "profession": "INGENIEUR",
      "status_matrimoniale": "Celibataire",
      "pays_de_residence": "SN",
      "residence": "DAKARE",
      "numero_du_jugement": "123",
      "date_du_jugement": "2024-04-03",
      "date_de_la_décision": "2024-04-03",
      "decision_judiciaire": "Mandat de dépot",
      "doctype": "Fiche_a_classer_v15",
      "reglement": [
          {
              "name": "77f1264ce0",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "reglement": "Réputé contradictoire",
              "parent": "0987654321",
              "parentfield": "reglement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_reglement"
          }
      ],
      "infractions": [
          {
              "name": "ea6090b3c2",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "date": "12/12/2024",
              "nature": "Agression",
              "parent": "0987654321",
              "parentfield": "infractions",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_infractions"
          }
      ],
      "emprisonnement": [
          {
              "name": "1b7d464365",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "type": "Ferme",
              "durée": "5",
              "périodicité": "An(s)",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          },
          {
              "name": "881d584c12",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 2,
              "type": "Sursis",
              "durée": "3",
              "périodicité": "Mois",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          }
      ],
      "amende": [
          {
              "name": "71c3e6dd06",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "montant": "2000000",
              "aux_depens_liquides_a_la_somme": "500000",
              "parent": "0987654321",
              "parentfield": "amende",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_amende"
          }
      ],
      "contraintes_par_corps": [
          {
              "name": "a69c18802c",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "debut": "2024-04-30",
              "fin": "2024-04-09",
              "main_leve": "2024-04-18",
              "parent": "0987654321",
              "parentfield": "contraintes_par_corps",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_contrainte_par_corps"
          }
      ],
      "affiliations": [
          {
              "name": "FC_AFF-000000000003",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "lien": "Pere",
              "nom": "Lamine",
              "prenom": "Anne",
              "identification_type": "CNI",
              "parent": "0987654321",
              "parentfield": "affiliations",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_affiliations"
          }
      ]
    },
    {
      "name": "1887650621",
      "owner": "Administrator",
      "creation": "2024-04-03 10:52:02.775307",
      "modified": "2024-04-03 10:52:02.775307",
      "modified_by": "Administrator",
      "docstatus": 0,
      "idx": 1,
      "type_didentification": "CIN",
      "numéros_didentification": "0987654321",
      "genre": "Homme",
      "nom": "Anne",
      "prenom": "Ibrahima Ba ",
      "nationalités": "Sénégalais(e)",
      "date_de_naissance": "2020-05-02",
      "profession": "INGENIEUR",
      "status_matrimoniale": "Celibataire",
      "pays_de_residence": "SN",
      "residence": "DAKARE",
      "numero_du_jugement": "027",
      "date_du_jugement": "2024-04-03",
      "date_de_la_décision": "2024-07-03",
      "decision_judiciaire": "Comdamnation",
      "doctype": "Fiche_a_classer_v15",
      "reglement": [
          {
              "name": "77f1264ce0",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "reglement": "Réputé contradictoire",
              "parent": "0987654321",
              "parentfield": "reglement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_reglement"
          }
      ],
      "infractions": [
          {
              "name": "ea6090b3c2",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "date": "12/12/2024",
              "nature": "Agression",
              "parent": "0987654321",
              "parentfield": "infractions",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_infractions"
          }
      ],
      "emprisonnement": [
          {
              "name": "1b7d464365",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "type": "Ferme",
              "durée": "5",
              "périodicité": "An(s)",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          },
          {
              "name": "881d584c12",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 2,
              "type": "Sursis",
              "durée": "3",
              "périodicité": "Mois",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          }
      ],
      "amende": [
          {
              "name": "71c3e6dd06",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "montant": "2000000",
              "aux_depens_liquides_a_la_somme": "500000",
              "parent": "0987654321",
              "parentfield": "amende",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_amende"
          }
      ],
      "contraintes_par_corps": [
          {
              "name": "a69c18802c",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "debut": "2024-04-30",
              "fin": "2024-04-09",
              "main_leve": "2024-04-18",
              "parent": "0987654321",
              "parentfield": "contraintes_par_corps",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_contrainte_par_corps"
          }
      ],
      "affiliations": [
          {
              "name": "FC_AFF-000000000003",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "lien": "Pere",
              "nom": "Lamine",
              "prenom": "Anne",
              "identification_type": "CNI",
              "parent": "0987654321",
              "parentfield": "affiliations",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_affiliations"
          }
      ]
    },
    {
      "name": "0987654321",
      "owner": "Administrator",
      "creation": "2024-04-03 10:52:02.775307",
      "modified": "2024-04-03 10:52:02.775307",
      "modified_by": "Administrator",
      "docstatus": 0,
      "idx": 0,
      "type_didentification": "CIN",
      "numéros_didentification": "0987654321",
      "genre": "Homme",
      "nom": "Anne",
      "prenom": "Ibrahima Ba ",
      "nationalités": "Sénégalais(e)",
      "date_de_naissance": "2020-05-02",
      "profession": "INGENIEUR",
      "status_matrimoniale": "Celibataire",
      "pays_de_residence": "SN",
      "residence": "DAKARE",
      "numero_du_jugement": "123",
      "date_du_jugement": "2024-04-03",
      "date_de_la_décision": "2024-04-03",
      "decision_judiciaire": "Mandat de dépot",
      "doctype": "Fiche_a_classer_v15",
      "reglement": [
          {
              "name": "77f1264ce0",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "reglement": "Réputé contradictoire",
              "parent": "0987654321",
              "parentfield": "reglement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_reglement"
          }
      ],
      "infractions": [
          {
              "name": "ea6090b3c2",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "date": "12/12/2024",
              "nature": "Agression",
              "parent": "0987654321",
              "parentfield": "infractions",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_infractions"
          }
      ],
      "emprisonnement": [
          {
              "name": "1b7d464365",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "type": "Ferme",
              "durée": "5",
              "périodicité": "An(s)",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          },
          {
              "name": "881d584c12",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 2,
              "type": "Sursis",
              "durée": "3",
              "périodicité": "Mois",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          }
      ],
      "amende": [
          {
              "name": "71c3e6dd06",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "montant": "2000000",
              "aux_depens_liquides_a_la_somme": "500000",
              "parent": "0987654321",
              "parentfield": "amende",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_amende"
          }
      ],
      "contraintes_par_corps": [
          {
              "name": "a69c18802c",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "debut": "2024-04-30",
              "fin": "2024-04-09",
              "main_leve": "2024-04-18",
              "parent": "0987654321",
              "parentfield": "contraintes_par_corps",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_contrainte_par_corps"
          }
      ],
      "affiliations": [
          {
              "name": "FC_AFF-000000000003",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "lien": "Pere",
              "nom": "Lamine",
              "prenom": "Anne",
              "identification_type": "CNI",
              "parent": "0987654321",
              "parentfield": "affiliations",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_affiliations"
          }
      ]
    },
    {
      "name": "1887650621",
      "owner": "Administrator",
      "creation": "2024-04-03 10:52:02.775307",
      "modified": "2024-04-03 10:52:02.775307",
      "modified_by": "Administrator",
      "docstatus": 0,
      "idx": 1,
      "type_didentification": "CIN",
      "numéros_didentification": "0987654321",
      "genre": "Homme",
      "nom": "Anne",
      "prenom": "Ibrahima Ba ",
      "nationalités": "Sénégalais(e)",
      "date_de_naissance": "2020-05-02",
      "profession": "INGENIEUR",
      "status_matrimoniale": "Celibataire",
      "pays_de_residence": "SN",
      "residence": "DAKARE",
      "numero_du_jugement": "123",
      "date_du_jugement": "2024-04-03",
      "date_de_la_décision": "2024-04-03",
      "decision_judiciaire": "Mandat de dépot",
      "doctype": "Fiche_a_classer_v15",
      "reglement": [
          {
              "name": "77f1264ce0",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "reglement": "Réputé contradictoire",
              "parent": "0987654321",
              "parentfield": "reglement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_reglement"
          }
      ],
      "infractions": [
          {
              "name": "ea6090b3c2",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "date": "12/12/2024",
              "nature": "Agression",
              "parent": "0987654321",
              "parentfield": "infractions",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_infractions"
          }
      ],
      "emprisonnement": [
          {
              "name": "1b7d464365",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "type": "Ferme",
              "durée": "5",
              "périodicité": "An(s)",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          },
          {
              "name": "881d584c12",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 2,
              "type": "Sursis",
              "durée": "3",
              "périodicité": "Mois",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          }
      ],
      "amende": [
          {
              "name": "71c3e6dd06",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "montant": "2000000",
              "aux_depens_liquides_a_la_somme": "500000",
              "parent": "0987654321",
              "parentfield": "amende",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_amende"
          }
      ],
      "contraintes_par_corps": [
          {
              "name": "a69c18802c",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "debut": "2024-04-30",
              "fin": "2024-04-09",
              "main_leve": "2024-04-18",
              "parent": "0987654321",
              "parentfield": "contraintes_par_corps",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_contrainte_par_corps"
          }
      ],
      "affiliations": [
          {
              "name": "FC_AFF-000000000003",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "lien": "Pere",
              "nom": "Lamine",
              "prenom": "Anne",
              "identification_type": "CNI",
              "parent": "0987654321",
              "parentfield": "affiliations",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_affiliations"
          }
      ]
    },
    {
      "name": "0987654321",
      "owner": "Administrator",
      "creation": "2024-04-03 10:52:02.775307",
      "modified": "2024-04-03 10:52:02.775307",
      "modified_by": "Administrator",
      "docstatus": 0,
      "idx": 0,
      "type_didentification": "CIN",
      "numéros_didentification": "0987654321",
      "genre": "Homme",
      "nom": "Anne",
      "prenom": "Ibrahima Ba ",
      "nationalités": "Sénégalais(e)",
      "date_de_naissance": "2020-05-02",
      "profession": "INGENIEUR",
      "status_matrimoniale": "Celibataire",
      "pays_de_residence": "SN",
      "residence": "DAKARE",
      "numero_du_jugement": "123",
      "date_du_jugement": "2024-04-03",
      "date_de_la_décision": "2024-04-03",
      "decision_judiciaire": "Mandat de dépot",
      "doctype": "Fiche_a_classer_v15",
      "reglement": [
          {
              "name": "77f1264ce0",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "reglement": "Réputé contradictoire",
              "parent": "0987654321",
              "parentfield": "reglement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_reglement"
          }
      ],
      "infractions": [
          {
              "name": "ea6090b3c2",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "date": "12/12/2024",
              "nature": "Agression",
              "parent": "0987654321",
              "parentfield": "infractions",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_infractions"
          }
      ],
      "emprisonnement": [
          {
              "name": "1b7d464365",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "type": "Ferme",
              "durée": "5",
              "périodicité": "An(s)",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          },
          {
              "name": "881d584c12",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 2,
              "type": "Sursis",
              "durée": "3",
              "périodicité": "Mois",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          }
      ],
      "amende": [
          {
              "name": "71c3e6dd06",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "montant": "2000000",
              "aux_depens_liquides_a_la_somme": "500000",
              "parent": "0987654321",
              "parentfield": "amende",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_amende"
          }
      ],
      "contraintes_par_corps": [
          {
              "name": "a69c18802c",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "debut": "2024-04-30",
              "fin": "2024-04-09",
              "main_leve": "2024-04-18",
              "parent": "0987654321",
              "parentfield": "contraintes_par_corps",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_contrainte_par_corps"
          }
      ],
      "affiliations": [
          {
              "name": "FC_AFF-000000000003",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "lien": "Pere",
              "nom": "Lamine",
              "prenom": "Anne",
              "identification_type": "CNI",
              "parent": "0987654321",
              "parentfield": "affiliations",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_affiliations"
          }
      ]
    },
    {
      "name": "1887650621",
      "owner": "Administrator",
      "creation": "2024-04-03 10:52:02.775307",
      "modified": "2024-04-03 10:52:02.775307",
      "modified_by": "Administrator",
      "docstatus": 0,
      "idx": 1,
      "type_didentification": "CIN",
      "numéros_didentification": "0987654321",
      "genre": "Homme",
      "nom": "Anne",
      "prenom": "Ibrahima Ba ",
      "nationalités": "Sénégalais(e)",
      "date_de_naissance": "2020-05-02",
      "profession": "INGENIEUR",
      "status_matrimoniale": "Celibataire",
      "pays_de_residence": "SN",
      "residence": "DAKARE",
      "numero_du_jugement": "123",
      "date_du_jugement": "2024-04-03",
      "date_de_la_décision": "2024-04-03",
      "decision_judiciaire": "Mandat de dépot",
      "doctype": "Fiche_a_classer_v15",
      "reglement": [
          {
              "name": "77f1264ce0",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "reglement": "Réputé contradictoire",
              "parent": "0987654321",
              "parentfield": "reglement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_reglement"
          }
      ],
      "infractions": [
          {
              "name": "ea6090b3c2",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "date": "12/12/2024",
              "nature": "Agression",
              "parent": "0987654321",
              "parentfield": "infractions",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_infractions"
          }
      ],
      "emprisonnement": [
          {
              "name": "1b7d464365",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "type": "Ferme",
              "durée": "5",
              "périodicité": "An(s)",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          },
          {
              "name": "881d584c12",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 2,
              "type": "Sursis",
              "durée": "3",
              "périodicité": "Mois",
              "parent": "0987654321",
              "parentfield": "emprisonnement",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_emprisonement"
          }
      ],
      "amende": [
          {
              "name": "71c3e6dd06",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "montant": "2000000",
              "aux_depens_liquides_a_la_somme": "500000",
              "parent": "0987654321",
              "parentfield": "amende",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_amende"
          }
      ],
      "contraintes_par_corps": [
          {
              "name": "a69c18802c",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "debut": "2024-04-30",
              "fin": "2024-04-09",
              "main_leve": "2024-04-18",
              "parent": "0987654321",
              "parentfield": "contraintes_par_corps",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_contrainte_par_corps"
          }
      ],
      "affiliations": [
          {
              "name": "FC_AFF-000000000003",
              "owner": "Administrator",
              "creation": "2024-04-03 10:52:02.775307",
              "modified": "2024-04-03 10:52:02.775307",
              "modified_by": "Administrator",
              "docstatus": 0,
              "idx": 1,
              "lien": "Pere",
              "nom": "Lamine",
              "prenom": "Anne",
              "identification_type": "CNI",
              "parent": "0987654321",
              "parentfield": "affiliations",
              "parenttype": "Fiche_a_classer_v15",
              "doctype": "fiche_a_classer_affiliations"
          }
      ]
    }

  ]

  getExecutionPeines(){
    return this.exec_peines;
  }
  getListFiches(){
    return this.list_fichesclasses;
  }
  getListAmmendes(){
    return this.list_ammendes;
  }

  jugements: any = [
  ]
  casiers = [
    {
      "name": "0123456789-00000023",
      "owner": "Administrator",
      "creation": "2024-01-18 13:20:44.543986",
      "modified": "2024-01-18 13:21:05.253157",
      "modified_by": "Administrator",
      "docstatus": 1,
      "idx": 0,
      "type_de_casier": "B3",
      "message_casier": "Ne comportant que le relevé des condamnations<br> des peines privatives de liberté sans sursis<br> Prononcées par un Tribunal Sénégalais (Article 734 du C.P.P)",
      "type_didentification": "CNI",
      "numero_didentication": "0123456789",
      "json_infractions": "<table class=\"table table-bordered\"><thead><tr><th>Date des Condamnations</th><th>Cours ou Tribunaux</th><th>Nature des Infractions</th><th>Crimes ou Délits</th><th>Nature et durée des peines</th><th>Observations</th></tr></thead><tbody><tr><td><br></td><td><br></td><td><br></td><td><br></td><td><br></td><td><br></td></tr><tr><td><br></td><td><br></td><td><br></td><td><br></td><td><br></td><td><br></td></tr><tr><td><br></td><td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                     </tr>                     <tr>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                     </tr>                     <tr>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                     </tr>                     <tr>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                     </tr>                  </tbody>             </table>",
      "barcode_yiku": "0123456789-00000023",
      "date_de_generation": "2024-01-18",
      "amended_from": null,
      "nom": "Diouf",
      "prenom": "Abdoulaye",
      "date_de_naissance": "1995-08-28",
      "lieu_de_naissance": "Dakar",
      "nationalite": "Sénégalais(e)",
      "domicile": "Pikine",
      "profession": "Sénégalais(e)",
      "nom_du_pere": "Diouf ",
      "nom_de_la_mere": "Diagne ",
      "jugements":"{\n    \"demandeur\": {\n        \"_assign\": null,\n        \"_comments\": null,\n        \"_liked_by\": null,\n        \"_user_tags\": null,\n        \"affiliations\": [\n            {\n                \"identification_number\": null,\n                \"identification_type\": \"CNI\",\n                \"lien\": \"Pere\",\n                \"nom\": \"TeTe\",\n                \"prenom\": \"Diouf\"\n            },\n            {\n                \"identification_number\": null,\n                \"identification_type\": \"CNI\",\n                \"lien\": \"Mere\",\n                \"nom\": \"TiTi\",\n                \"prenom\": \"Diagne\"\n            }\n        ],\n        \"creation\": \"2024-01-17 14:49:07.435177\",\n        \"date_de_naissance\": \"1995-08-28\",\n        \"docstatus\": 1,\n        \"domicile\": \"Pikine\",\n        \"genre\": \"Homme\",\n        \"idx\": 0,\n        \"lieu_de_naissance\": \"Dakar\",\n        \"modified\": \"2024-01-17 14:49:33.939451\",\n        \"modified_by\": \"Administrator\",\n        \"name\": \"Toto Diouf\",\n        \"nationalit\és\": \"S\én\égalais(e)\",\n        \"nom\": \"Diouf\",\n        \"owner\": \"Administrator\",\n        \"photo\": null,\n        \"prenom\": \"Toto\",\n        \"status_marital\": \"Celibataire\"\n    },\n    \"infractions\": [],\n    \"list\": [\n        {\n            \"date_de_decision\": \"2024-01-18\",\n            \"date_de_jugement\": \"2024-01-18\",\n            \"decision_judiciaire\": null,\n            \"emprisonement\": [],\n            \"genre\": \"Homme\",\n            \"identification_type\": \"CNI\",\n            \"identification_value\": \"0123456789\",\n            \"infractions\": [\n                {\n                    \"nature\": \"Blanchiment d'argent\"\n                }\n            ],\n            \"nom\": \"Diouf\",\n            \"numero_de_jugement\": \"002\",\n            \"prenom\": \"Toto\",\n            \"status\": \"En attente du Jugement\",\n            \"tribunal\": \"TI de Dakar\"\n        }\n    ]\n}",
      "is_printable": "1"
    },
    {
      "name": "0123456789-00000061",
      "owner": "Administrator",
      "creation": "2024-03-07 11:28:23.610162",
      "modified": "2024-03-07 11:28:32.494465",
      "modified_by": "Administrator",
      "docstatus": 1,
      "idx": 0,
      "type_de_casier": "B3",
      "message_casier": "Ne comportant que le relevé des condamnations<br> des peines privatives de liberté sans sursis<br>\n                    Prononcées\n                    par un Tribunal Sénégalais (Article 734 du C.P.P)",
      "type_didentification": "CNI",
      "numero_didentication": "0123456789",
      "json_infractions": "<table class=\"table table-bordered\"><thead><tr><th>Date de condamnation</th><th>Cour Ou Tribunal</th><th>Nature des infractions</th><th>Condamnation</th><th>Status</th></tr></thead>\n<tbody>\n<tr><td> </td><td> </td><td> </td><td></td><td> </td></tr>\n<tr><td> </td><td> </td><td> </td><td></td><td> </td></tr>\n<tr><td> </td><td> </td><td> </td><td></td><td> </td></tr><tr>\n<td> </td><td> </td><td> </td><td></td><td> </td></tr>\n<tr><td> </td><td> </td><td> </td><td></td><td> </td></tr><tr><td> </td><td> </td><td> </td><td> </td><td> </td></tr>\n</tbody></table>",
      "barcode_yiku": null,
      "date_de_generation": "2024-03-07",
      "amended_from": null,
      "nom": "Mouctar",
      "prenom": "Ba",
      "date_de_naissance": null,
      "lieu_de_naissance": null,
      "nationalite": null,
      "domicile": null,
      "profession": null,
      "nom_du_pere": null,
      "nom_de_la_mere": null,
      "jugements": null,
      "is_printable": "0"
    },
    {
      "name": "0987654321-00000030",
      "owner": "juge@justice.sn",
      "creation": "2024-01-19 17:07:57.637270",
      "modified": "2024-01-19 17:08:29.496620",
      "modified_by": "juge@justice.sn",
      "docstatus": 1,
      "idx": 0,
      "type_de_casier": "B3",
      "message_casier": "Ne comportant que le relevé des condamnations<br> des peines privatives de liberté sans sursis<br> Prononcées par un Tribunal Sénégalais (Article 734 du C.P.P)",
      "type_didentification": "CNI",
      "numero_didentication": "0987654321",
      "json_infractions": "<table><thead><tr><th>Date des Condamnations</th><th>Cours ou Tribunaux</th><th>Nature des Infractions</th><th>Crimes ou Délits</th><th>Nature et durée des peines</th><th>Observations</th></tr></thead><tbody><tr><td><br></td><td><br></td><td><br></td><td><br></td><td><br></td><td><br></td></tr><tr><td><br></td><td><br></td><td><br></td><td><br></td><td><br></td><td><br></td></tr><tr><td><br></td><td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                     </tr>                     <tr>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                     </tr>                     <tr>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                     </tr>                     <tr>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                         <td><br></td>                     </tr>                  </tbody>             </table>",
      "barcode_yiku": "0987654321-00000030",
      "date_de_generation": "2024-01-19",
      "amended_from": null,
      "nom": "Gueye",
      "prenom": "Aissatou",
      "date_de_naissance": "1995-08-24",
      "lieu_de_naissance": "Banjul",
      "nationalite": "Gambien(ne)",
      "domicile": "Dakar",
      "profession": "Gambien(ne)",
      "nom_du_pere": "Gueye Rere",
      "nom_de_la_mere": "Kagne Ruru",
      "jugements":"{\n    \"demandeur\": {\n        \"_assign\": null,\n        \"_comments\": null,\n        \"_liked_by\": null,\n        \"_user_tags\": null,\n        \"affiliations\": [\n            {\n                \"identification_number\": null,\n                \"identification_type\": \"CNI\",\n                \"lien\": \"Pere\",\n                \"nom\": \"Rere\",\n                \"prenom\": \"Gueye\"\n            },\n            {\n                \"identification_number\": null,\n                \"identification_type\": \"CNI\",\n                \"lien\": \"Mere\",\n                \"nom\": \"Ruru\",\n                \"prenom\": \"Kagne\"\n            }\n        ],\n        \"creation\": \"2024-01-17 14:52:51.507884\",\n        \"date_de_naissance\": \"1995-08-24\",\n        \"docstatus\": 1,\n        \"domicile\": \"Dakar\",\n        \"genre\": \"Femme\",\n        \"idx\": 0,\n        \"lieu_de_naissance\": \"Banjul\",\n        \"modified\": \"2024-01-17 14:53:08.711320\",\n        \"modified_by\": \"Administrator\",\n        \"name\": \"Tata Gueye\",\n        \"nationalit\és\": \"Gambien(ne)\",\n        \"nom\": \"Gueye\",\n        \"owner\": \"Administrator\",\n        \"photo\": null,\n        \"prenom\": \"Tata\",\n        \"status_marital\": \"Divorc\é(e)\"\n    },\n    \"infractions\": [],\n    \"list\": [\n        {\n            \"date_de_decision\": \"2024-01-18\",\n            \"date_de_jugement\": \"2024-01-17\",\n            \"decision_judiciaire\": \"Peine de prison ferme ou avec sursis\",\n            \"emprisonement\": [\n                {\n                    \"dur\ée\": \"2\",\n                    \"p\ériodicit\é\": \"An(s)\",\n                    \"type\": \"Ferme\"\n                }\n            ],\n            \"genre\": \"Femme\",\n            \"identification_type\": \"CNI\",\n            \"identification_value\": \"0987654321\",\n            \"infractions\": [\n                {\n                    \"nature\": \"Agression\"\n                }\n            ],\n            \"nom\": \"Gueye\",\n            \"numero_de_jugement\": \"001\",\n            \"prenom\": \"Tata\",\n            \"status\": \"Decision rendue\",\n            \"tribunal\": \"TI de Dakar\"\n        }\n    ]\n}",
      "is_printable": "1"
    },
  ]
  list_personnes = [
    {
        'id':1,
        'nom': 'Diop',
        'prenom': 'yaya',
        'genre': 'Masculin',
        'nationalités': 'Sénégalais',
        'domicile': 'Jaxay',
        'date_de_naissance': '1996/03/27',
        'lieu_de_naissance': 'Dakar',
        'status_marital': 'Célibataire',
       'type_didentification': 'CNI',
        'numero_didentication': '123456789',
        'affiliation':[
            {
                'lien': 'pere',
                'nom': 'Diop',
                'prenom': 'Abdou',
            }
        ],
        'contact':[
            {
                'type': 'telephone',
                'libelle': '',
                'valeur': '772678907',
            }
        ],
        'condamnations':[
            {
                'nom': 'Amende',

            }
        ]
    },
    {
        'id':2,
        'nom': 'Ndiaye',
        'prenom': 'Thierno',
        'genre': 'Masculin',
        'nationalités': 'Sénégalais',
        'domicile': 'Jaxay',
        'date_de_naissance': '1996/03/27',
        'lieu_de_naissance': 'Dakar',
        'status_marital': 'Célibataire',
        'type_didentification': 'CNI',
        'numero_didentication': '123456789',
        'affiliation':[
            {
                'lien': 'pere',
                'nom': 'Diop',
                'prenom': 'Abdou',
            }
        ],
        'contact':[
            {
                'type': 'telephone',
                'libelle': '',
                'valeur': '772678907',
            }
        ],
        'condamnations':[
            {
                'nom': 'prison',

            }
        ]
    },
    {
        'id':3,
        'nom': 'Seck',
        'prenom': 'ibrahim',
        'genre': 'Masculin',
        'nationalités': 'Sénégalais',
        'domicile': 'Jaxay',
        'date_de_naissance': '1996/03/27',
        'lieu_de_naissance': 'Dakar',
        'status_marital': 'Célibataire',
        'type_didentification': 'CNI',
        'numero_didentication': '123456789',

        'affiliation':[
            {
                'lien': 'pere',
                'nom': 'Diop',
                'prenom': 'Abdou',
            }
        ],
        'contact':[
            {
                'type': 'telephone',
                'libelle': '',
                'valeur': '772678907',
            }
        ]
    }
  ]

  getCasiers(){

    this.casiersChange.next(this.casiers);
    return this.casiers;

    // return this.http.get<any>(this.API_URL + 'public/currencies/' )
  }

  getJugements(){
    this.jugementsChange.next(this.jugements);
    return this.jugements;
    // return this.http.get<any>(this.API_URL + 'public/currencies/' )
  }
}
